import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    indexPagePos: 0,
    sign: sessionStorage.getItem('sign') ? sessionStorage.getItem('sign') : null
}
const mutations = {
    SET_INDEX_PAGE_POS(state, pos) {
        state.indexPagePos = pos;
    },
    SET_SIGN(state, sign) {
        sessionStorage.setItem('sign', JSON.stringify(sign));
        state.sign = JSON.stringify(sign);
    }
}

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js